import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, switchMap } from 'rxjs/operators';
import { CognitoAuthFacade } from '@cpd-app/state/cognito-auth';
import { Observable } from 'rxjs';
import { NotEnoughCreditDialogComponent } from '@cpd-app/core-module/components/not-enough-credit-dialog/not-enough-credit-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class RefreshCreditPromptService {
  public constructor(
    private dialog: MatDialog,
    private cognitoAuthFacade: CognitoAuthFacade
  ) {}

  public openRefreshCreditDialog(resetTime: number | string): void {
    this.cognitoAuthFacade.isAuthenticated$
      .pipe(
        switchMap((isAuthenticated) => {
          if (isAuthenticated) {
            return this.openRefreshCredit(resetTime);
          }
        })
      )
      .subscribe();
  }

  private openRefreshCredit(resetTime: number | string): Observable<boolean> {
    return this.dialog
      .open(NotEnoughCreditDialogComponent, {
        ariaLabel: 'Not enough credits',
        width: '580px',
        disableClose: false,
        data: {
          resetTime: resetTime
        }
      })
      .afterClosed()
      .pipe(map(() => true));
  }
}
